<template>
  <div class="d-flex-row flex-4 justify-start align-start packs flex-wrap">
    <template v-if="!is_mmo && selectedGameSlug">
      <PackCard
        v-for="(gamePack, i) in packs"
        :key="gamePack.slug"
        :id="gamePack.id"
        :title="gamePack.short_title"
        :full-title="gamePack.title"
        :slug="gamePack.slug"
        :image="gamePack.image"
        :index="i"
        :perks="gamePack?.perks || []"
        :link="`/${selectedGameSlug}/${gamePack.slug}`"
        :current-game-slug="selectedGameSlug"
        :is-new="gamePack?.is_new === true ? 1 : 0"
        :slider-chip="false"
      />
    </template>
    <template v-else-if="is_mmo && selectedGameSlug">
      <MmoHotCategoryCard
        v-for="pack in packs"
        :key="pack"
        :image="image(pack)"
        :short_title="pack.short_title"
        :perks="pack.perks"
        :slug="pack.slug"
        :current-game-slug="selectedGameSlug"
      />
    </template>
  </div>
</template>

<script setup>
import PackCard from "../cards/PackCard.vue";
import MmoHotCategoryCard from "../cards/MmoHotCategoryCard.vue";
const { locale } = useI18n();
const props = defineProps({
  selectedGameSlug: {
    default: "",
  },
  isOpen: {
    default: false,
  },
});
const { getLocale } = useFunctions();
const mmoGames = ["world-of-warcraft-boost"];

const packs = ref([]);
const categories = ref([]);
const is_mmo = ref(false);

const game_packs = ref({});
const fetchData = async () => {
  try {
    if (Object.keys(game_packs.value)?.length > 0) return;
    const response = await $fetch(`/api/packs/${locale.value}`);
    game_packs.value = response;
  } catch (error) {
    console.log(error);
  }
};

if (props.isOpen) {
  fetchData();
}

const fetchPacks = () => {
  const pcks = game_packs.value[props.selectedGameSlug];
  if (mmoGames.includes(props.selectedGameSlug)) {
    is_mmo.value = true;
  } else {
    is_mmo.value = false;
  }
  if (pcks) {
    packs.value = [...pcks];
  }
};

const image = (pack) => {
  return `/images/games/world-of-warcraft-boost/packs/${pack.slug}-plain.webp`;
};

watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      fetchData();
    } else {
      // game_packs.value = {};
      // packs.value = [];
    }
  }
);

watch(
  () => props.selectedGameSlug,
  (newVal) => {
    if (newVal) {
      fetchPacks();
    } else {
      // game_packs.value = {};
      // packs.value = [];
    }
  }
);
</script>
